import AddressSelectionCard from "../bookings/AddressSelectionCard";

const PackageAddressStep = ({ bookingData, setBookingData }) => {
  return (
    <div className="p-4">
      <AddressSelectionCard
        bookingData={bookingData}
        setBookingData={setBookingData}
      />
    </div>
  );
};

export default PackageAddressStep;